"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { QuestCard } from "@/app/quests/_components/quest-card";
import { useGetCampaignTaskStatus, useGetCampaign } from "@/hooks/challenges";
import { CAMPAIGN_CONFIG } from "@/config";
import { ChallengeCampaignEventState } from "@/types/challenges.types";

export function QuestsSpotlightSection() {
  const router = useRouter();

  const { data: tasksData } = useGetCampaignTaskStatus(
    CAMPAIGN_CONFIG.id,
    CAMPAIGN_CONFIG.groupId
  );

  const { data: campaign } = useGetCampaign(
    CAMPAIGN_CONFIG.id,
    CAMPAIGN_CONFIG.groupId
  );

  // Get first 4 enabled, uncompleted quests, or first 4 enabled if all completed
  const displayQuests = tasksData?.tasksStatus
    ?.filter((task) => task.isEnabled && task.status !== ChallengeCampaignEventState.SUCCESSFUL)
    .slice(0, 4) || tasksData?.tasksStatus?.filter((task) => task.isEnabled).slice(0, 4) || [];

  // If no quests yet, don't render
  if (!displayQuests.length) {
    return null;
  }

  const handleQuestClick = (taskGuid: string) => {
    router.push(`/quests?taskGuid=${taskGuid}`);
  };

  return (
    <section className="relative w-full bg-black py-12 md:py-16 lg:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8">
            Earn points with Yiedl Quests
          </h2>
        </div>

        {/* Quest Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {displayQuests.map((quest) => {
            const challengeTask = campaign?.tasks?.find((t: any) => t.id === quest.taskGuid);

            return (
              <QuestCard
                key={quest.taskGuid}
                quest={quest}
                challengeTask={challengeTask}
                onClick={() => handleQuestClick(quest.taskGuid)}
                isLocked={false}
              />
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="flex justify-center">
          <Link href="/quests">
            <Button
              variant="primary"
              size="default"
              className="font-semibold rounded-xl transition-all duration-200 ease-out"
            >
              Go to Quests Page
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}